import React, {useEffect, useState} from 'react';

import CanvasJSChart from "./CanvasJSChart";
import SpinnerDiv from "root/Components/SpinnerDiv";
import { getPanelHeader } from "./DashboardPanelFunctions";
import {getDataFromResponse, getNumRowsFromResponse} from "root/DataFunctions/BaseDataFns";
import {getMonthName, getMessagesMadeByChild} from "root/DataFunctions/DashboardDataFns";
import {MessageType, UserTypes} from "root/DataFunctions/Constants";
import {dashboardDefaults, defaultTitleFontSize} from "root/dashboard/DashboardDefault";

const DashboardPanelChildMessagesSent = (props) =>
{
	const [ data, setData ] = useState ({ loading: true, data: []}) ;

	useEffect(() =>
	{
		getServerData() ;
	}, [props.user_type, props.month]);

    const generateDataPoints = ( items ) =>
	{
		return items.map ((item) =>
			{
				const key = item.monkey;
				const yr = key.substring ( 0, 4 );
				const mo = (key.substring (  4, 7 )) - 1;
				const monthName = getMonthName(+mo);
				const shortMonth = monthName.substring(0,3);
				const label = shortMonth + ' ' + yr ;

				return ({
					label: label,
					y: Number(item.count),
					tool: item.count
				})
			}
		)
	}

	const getServerData = () => {

		getMessagesMadeByChild( props.child_uid,   UserTypes.CHILD, props.month, props.year, MessageType.MESSAGE_TYPE_MESSAGE, (response) =>
		{
			const recs = getDataFromResponse(response);

			setData ( { loading: false, data : recs}) ;
		});
	};

	const formPanel = () =>
	{
		const options = {
			maintainAspectRatio: false,
			responsive: true,
			animationEnabled: true,
			height: props.height,
			...dashboardDefaults,
			title: {
				text: props.title,
				fontSize: defaultTitleFontSize
			},
			data: [
				{
					type: 'column',
					lineColor: 'red',
					indexLabelPlacement: 'inside',    //Try Changing to outside
					showInLegend: true,
					legendMarkerColor: 'grey',
					legendText: 'Number of Messages',
					toolTipContent: '{tool}',
					dataPoints: generateDataPoints(data.data)
				}
			] } ;

		return (
			<div className={'panel ' + props.panelStyle}>
				{ getPanelHeader({ title: props.title })}
				<div className='panel-body'>
					<CanvasJSChart id='messagesSent' options={options} uniqueId='messagesSent' />
				</div>
			</div>
		)
	}

	return data.loading === true ? <SpinnerDiv/> : formPanel() ;
}

export default DashboardPanelChildMessagesSent;

DashboardPanelChildMessagesSent.defaultProps =
{
	title: 'title',
	height: 500,
	panelStyle: 'panel-default',
}